import React from "react"
import { Link } from "react-router-dom"

import { StringHelper, _ } from '../../strings'

export class IndexFooter extends React.Component {

	render() {
    const currentYear = new Date().getFullYear(); 
    const copyrightYear = _("tih_copyright").replace("2024", `2017 - ${currentYear}`);

    return (
        <footer className="vertical-flex-item">
          <div className="footer-container vertical-flex-item ">
            <div className="footer-brand">{_("page_company_name")}</div>
            {/*<div className="footer-copyright"><Link to="/privacy-policy">Privacy Policy</Link></div>*/}
            <div className="footer-copyright">{copyrightYear}</div>
            <div className="footer-privacy-policy"><Link to="/privacy-policy">{_("privacy_policy")}</Link></div>
          </div>
        </footer>
    );

  }

}
